import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule, MatIconModule],
  selector: 'app-device-not-authorized',
  templateUrl: './device-not-authorized.component.html',
  styleUrls: ['./device-not-authorized.component.scss']
})
export class DeviceNotAuthorizedComponent {

  constructor(
    private router: Router
  ) {}

  goToLogin() {
    this.router.navigate(['/auth/login']);
  }

}

